// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._ahbq1ejb{margin-inline-start:var(--ds-space-300,24px)}\n._ahbqxy5q{margin-inline-start:var(--ds-space-400,2pc)}", ""]);
// Exports
module.exports = exports;
